// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"fe49dbd7","391":"ed27e300","427":"6dbafa9d","453":"dafaa0a9","832":"ad93c211","850":"41629572","938":"17b65899"}[chunkId] + ".chunk.js";
};